// F6 : KPI recalculés sur les PAV retenus. `etats` est la Map<pavId, état> d'`etatsDesPav`.

export function kpi(pavsRetenus, etats, acte) {
    let ras = 0;
    let enDefaut = 0;
    let impossibles = 0;
    let nonInspectes = 0;
    let photos = 0;
    let realises = 0;
    let impossiblesPassages = 0;
    let tonnageKg = 0;
    let nbCollectes = 0;
    let nbDeclasses = 0;

    for (const pav of pavsRetenus) {
        const etat = etats.get(pav.id);
        if (etat.verdict === 'ras') ras++;
        else if (etat.verdict === 'pb') enDefaut++;
        else if (etat.verdict === 'imp') impossibles++;
        else nonInspectes++;
        photos += etat.nbPhotos;
        realises += etat.nbLavages;
        impossiblesPassages += etat.nbImpossibles;
        tonnageKg += etat.tonnageKg || 0;
        nbCollectes += etat.nbCollectes || 0;
        nbDeclasses += etat.nbDeclasses || 0;
    }

    const parc = pavsRetenus.length;
    const inspectes = parc - nonInspectes;
    return {
        parc,
        inspectes,
        ras,
        enDefaut,
        impossibles,
        nonInspectes,
        couverture: parc > 0 ? inspectes / parc : null,
        tauxService: acte === 'lavage' && parc > 0 ? (ras + enDefaut) / parc : null,
        photos,
        realises,
        tentatives: realises + impossiblesPassages,
        // Pas d'historique de planning en V1 : le dashboard affiche « — » (à trancher avant le lot 5).
        planifies: null,
        // Collecte simulée (lot 8), sur la plage : tonnage en kg, collectes (déclassés compris), déclassés.
        tonnageKg,
        nbCollectes,
        nbDeclasses,
    };
}
